import React from "react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "../misc/Dialog";
import { Button } from "../misc/Button";
import { ListingVideos } from "../../types/listingVideos";
import { ScrollArea } from "../calendar/ScrollArea";

interface VideoConversionErrorDialogProps {
    open: boolean;
    videos: ListingVideos[];
    onClose: () => void;
}

const VideoConversionErrorDialog: React.FC<VideoConversionErrorDialogProps> = ({
    open,
    videos,
    onClose,
}) => {
    return (
        <Dialog open={open}>
            <DialogContent
                className="sm:max-w-[425px] h-full bg-white flex flex-col justify-between"
                dark={true}
            >
                <div>
                    <DialogHeader>
                        <DialogTitle className="text-2xl font-bold">
                            Video Conversion Failed
                        </DialogTitle>
                    </DialogHeader>
                    <div className="py-4">
                        <p className="text-muted-foreground mb-4">
                            One or more videos failed to process. Please try
                            again.
                        </p>
                        <ScrollArea className="relative h-full w-full rounded-md border p-4">
                            <div className="grid grid-cols-2 gap-4">
                                {videos.map((video) => (
                                    <div
                                        key={video.id}
                                        className="relative aspect-video overflow-hidden rounded-lg"
                                    >
                                        <video
                                            src={video.signedUrl || video.url}
                                            controls
                                            className="absolute inset-0 h-full w-full object-contain"
                                            muted
                                        >
                                            Your browser does not support the
                                            video tag.
                                        </video>
                                    </div>
                                ))}
                            </div>
                        </ScrollArea>
                    </div>
                </div>
                <div className="flex justify-end">
                    <Button variant="default" onClick={onClose}>
                        Close
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default VideoConversionErrorDialog;
